// import { useCallback } from 'react'
import { ENV_RENDER_DESIGNER } from '../../utils/constants'
import ReferCache from './ReferCache'
import { removeRepeat } from '../../utils';

// 设计器态
export function isDesigner(props) {
  return props.renderEnv === ENV_RENDER_DESIGNER
}

/**
 * 预览态显示值逻辑
 */
// 是否有显示值
function hasShowValue(props) {
  const value = getValue(0, props);
  return value ? true : false;
}

function getValue(index, props) {
  let nameKey;
  let value;
  if (typeof props.refReturn === 'string') {
    nameKey = props.refReturn;
  } else {
    nameKey = props.refReturn[0];
  }
  if (!isMultiple(props)) {
    value = props.value[nameKey];
  } else {
    value = props.value[0][nameKey];
  }
  return value;
}

function getValueByName(name) {

}

// 获取显示值
export function getShowValue(props, referContext) {
  if (isMultiple(props)) return // 只展示单选
  const { value } = props;
  if (!value || value.length === 0) return ''
  const cEntityKeyFld = getCEntityKeyFld(props)
  // if(hasShowValue(props)) { // 有显示值
  return formatShowValueFromProps(props, props.value);
  // } else { // 没有显示值时
  //   if (!isMultiple(props) && props.value[cEntityKeyFld]) { // 单选 有id值
  //     loadShowValue(props, referContext, cEntityKeyFld);
  //   } else if (isMultiple(props) && props.value[0][cEntityKeyFld]) { // 多选 有id值
  //     loadShowValue(props, referContext, cEntityKeyFld);
  //   } else { // 无id
  //     return ''
  //   }
  // }
}

// 格式化显示值
export function formatShowValueFromProps(props, value) {
  if (!value || value.length === 0) {
    return ''
  }
  const { refReturn = [] } = props
  if (isCustomRefReturn(refReturn, props)) {
    return isCustomRefReturn(refReturn, props)
  }
  let showName = '' // 显示值
  // if (!isMultiple(props)) { // 单选
    if (typeof refReturn === 'string') {
      showName = mulLanguage(value?.[refReturn]) ?? ''
    } else {
      let nameArr = []
      refReturn.map(i => {
        if (value?.[i] !== undefined) nameArr.push(mulLanguage(value[i]))
      });
      showName = nameArr.join('-')
    }
    
  // } else { // 多选
  //   if (value && !Array.isArray(value)) {
  //     value = [value]
  //   }
  //   showName = mulFieldShow(props, value)
  // }
  return showName
}

// 用户自定义显示值
function isCustomRefReturn(refReturn, props) {
  const rootStore = props.pageStore.rootStore;
  if (typeof refReturn === 'string' && refReturn.startsWith('mobx://')) { // 如果是用户自定义显示,直接返回,不走内置解析
    return eval(refReturn.replace("mobx://", ''))
  } else {
    if (refReturn[0]?.startsWith('mobx://')) {
      return eval(refReturn[0].replace("mobx://", ''))
    }
  }
  return false
}

// 没有显示值时加载缓存
export async function loadShowValue(props, referContext, cEntityKeyFld, callback) {
  try {
    // 构建key值
    const domainKey = props.pageStore.params.domainKey;
    const serviceCode = props.pageStore.query.serviceCode;
    let key = `${location.origin}_${props.refCode}_${domainKey}_${serviceCode}`
    // 初始化缓存对象
    const cache = await ReferCache.getInstance(key);
    cache.cEntityKeyFld = cEntityKeyFld
    let value = handleValue(props, props.value);
    cache.id = value.map(i => i[cEntityKeyFld]).join()
    // 取缓存值
    const data = await cache.getData(props, referContext, cEntityKeyFld)
    if (data && data.length > 0) {
      if (isMultiple(props)) { // 多选时不往store中塞值, 只展示, 还未研究清楚多选赋值
        callback(removeRepeat(data, cEntityKeyFld))
      } else {
        setStore(props, data);
      }
    } else if (props.showCEntityKeyFld){ // 无显示值时显示主键值
      setNameReplaceId(props, cEntityKeyFld, callback)
    } else if (isMultiple(props)) { // 多选时不往store中塞值, 只展示, 还未研究清楚多选赋值
      callback(removeRepeat(data, cEntityKeyFld))
    }
  } catch (error) {
    console.error(error);
    setNameReplaceId(props, cEntityKeyFld, callback)
  }
}

function setNameReplaceId (props, cEntityKeyFld, callback) {
  if (props.showCEntityKeyFld) { // 无显示值时显示主键值
    const { refReturn } = props;
    let _refReturn = '';
    if (typeof refReturn === 'string') { // 单字段
      _refReturn = refReturn
    } else {
      _refReturn = refReturn[0];
    }
    if (!isMultiple(props)) { // 单选
      props.onChange({
        ...props.value,
        [_refReturn]: props.value[cEntityKeyFld]
      })
    } else { // 多选
      const data = props.value.map(item => {
        item[_refReturn] = item[cEntityKeyFld]
        return item
      })
      callback(data)
    }
  }
}

// 回写到store中
function setStore(props, data) {
  let value = handleValue(props, props.value);
  let newArr = data.map((item, index) => {
    return Object.assign({}, value[index], item)
  })
  if (!isMultiple(props)) { // 单选
    props.onChange(newArr[0])
  } else {
    props.onChange(newArr)
  }
}

// 多选字段回显
export function mulFieldShow(props, value) {
  const { refReturn } = props;
  if (typeof refReturn === 'string') { // 单字段
    return value.map(val => mulLanguage(val[refReturn])).join(',');
  } else { // 多字段(合并显示字段)
    return value.map(val => refReturn.map(i => val[i]).join('-')).join(',')
  }
}

// 多语
export function mulLanguage(text) {
  let _text = '';
  if (typeof text === 'object' && text !== null) {
    // _text = text[ctx.appCtx.localLanguage.tenantLangCode];
    _text = text[lang?.lang || 'zh_CN'];
  } else {
    try {
      _text = text.toString();
    } catch (error) {
      _text = '';
    }
  }
  return _text;
}

// 是否多选
export function isMultiple(props) {
  const { selectType = 'single', value, multiple, canMultiple } = props
  if (multiple || canMultiple) return true
  if (selectType === 'single' && !Array.isArray(value)) { // 单选
    return false
  } else {
    return true
  }
}

// 处理value值
export function handleValue(props, val) {
  let value = [];
  if (!isMultiple(props)) { // 单选
    value = [val]
  } else {
    value = val;
  }
  return value;
}

export function getRefReturn(props) {
  const s = props.refReturn;
  if (typeof s === "string") {
    return [s];
  }
  return s;
}

function getRefReturnByIndex(props, idx) {
  const s = getRefReturn(props);
  if (s.length > idx) {
    return s[idx];
  }
  throw new Error('index out');
}

// 值改变时判断是否需要更新显示值
export function onChangeValue(newValue, oldValue, props, referContext, callback) {
  if (!newValue) {
    // 多选参照为空时直接return;
    callback(newValue)
    return;
  } 
  const cEntityKeyFld = getCEntityKeyFld(props);
  if (isNeedQueryReferData(props, newValue, oldValue, cEntityKeyFld)) {
    loadShowValue(props, referContext, cEntityKeyFld, callback)
  }
}

function isNeedQueryReferData(props, newValue, oldValue, cEntityKeyFld) {
  if (isMultiple(props)) {
    return true;
  }
  const newId = newValue?.[cEntityKeyFld] ?? '';
  const oldId = oldValue?.[cEntityKeyFld] ?? '';
  const key = getRefReturnByIndex(props, 0);
  const newName = newValue?.[key] ?? '';
  const oldName = oldValue?.[key] ?? '';
  if (newId !== oldId && newName !== oldName) {
    return false
  } else if (newId === oldId && newName === oldName) {
    return false
  } else {
    return true
  }
}

// 获取参照主键字段
export function getCEntityKeyFld(props) {
  let refReturnArr = JSON.parse(props.refReturnArr); // 实体字段和参照字段映射关系
  let cEntityKeyFld = 'id' // 主键, 默认为id
  for (let i in refReturnArr) {
    if (refReturnArr[i] === props.storeField) {
      cEntityKeyFld = i;
    }
  }
  return cEntityKeyFld
}

// 是否在初始化时加载
export function needInitLoadShowValue(props) {
  const { value } = props;
  if (isDesigner(props) || !value || value.length === 0) return;
  const key = getRefReturnByIndex(props, 0);
  const cEntityKeyFld = getCEntityKeyFld(props);
  let id = '', name = '';
  if (isMultiple(props)) { // 多选
    id = value[0]?.[cEntityKeyFld];
    name = value[0]?.[key];
  } else {
    id = value[cEntityKeyFld];
    name = value[key];
  }
  return id && !name
}